import axios from '../../utils/axios';

export const updateTeam = async (partnerId, teamId, data) => {
  const response = await axios.put(
    `/partners/${partnerId}/teams/${teamId}`,
    data
  );
  return response.data;
};
